import { Button, Fab, Snackbar, TextField, Typography } from '@material-ui/core';
import { AddIcon, ColDef } from '@material-ui/data-grid';
import { Alert } from '@material-ui/lab';
import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom';
import DataTable from '../../components/DataTable';
import Loading from '../../components/Loading';
import api from '../../config/api'
import { Container } from './styles'


interface AgroProductNormalized {
    id: number
    description: string,
    value: number,
    production: number,
    production_cost: number,
    category: string,
    active: string
    cod: number,
    unity: string
}

interface Unity {
    id: number
    description: string
}

interface Category {
    id: number
    description: string
}

interface AgroProduct {
    id: number
    description: string,
    value: number,
    production: number,
    production_cost: number,
    year: Date
    category_id: number,
    category: Category
    active: boolean,
    cod: number,
    unity_id: number,
    unity: Unity
}

function AgroProducts() {
    const [agroProducts, setAgroProducts] = useState<AgroProductNormalized[]>([])
    const [search, setSearch] = useState('')
    const [filtered, setFiltered] = useState<AgroProductNormalized[]>([])
    const [selected, setSelected] = useState([])

    const [openSuccess, setOpenSuccess] = useState(false);
    const [openFailed, setOpenFailed] = useState(false);
    const [errorMessage, setErrorMessage] = useState("Erro desconhecido");

    const [loading, setLoading] = useState(false)

    const history = useHistory()


    useEffect(() => {
        setLoading(true)
        fetchAgroProducts()
    }, [])

    async function fetchAgroProducts() {
        const agroProductsRequest = await api.get('/agroproducts')

        const normalizedAgro = agroProductsRequest.data.agroProducts
            .filter((item: AgroProduct) => item.active)
            .map((item: AgroProduct) => {
                //@ts-ignore
                return {
                    id: item.id,
                    description: item.description,
                    value: item.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                    category: item.category.description,
                    year: item.year.toString().substr(0, 4),
                    cod: item.cod,
                    production: item.production.toLocaleString('pt-BR'),
                    unity: item.unity.description,
                    production_cost: item.production_cost.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                } as AgroProductNormalized
            })


        setAgroProducts(normalizedAgro)
        setFiltered(normalizedAgro)
        setLoading(false)
    }

    const handleCloseSuccess = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSuccess(false);
    };

    const handleCloseFailed = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenFailed(false);
    };

    function handleSelected(ids: any) {
        setSelected(ids)
    }

    async function handleDelete() {
        try {
            if (selected.length === 1) {
                const id = selected[0]
                await api.put(`/agroproducts/${id}/disable`)
            } else {
                await api.delete(`/agroproducts/deletebatch`,
                    {
                        data: {
                            products_id: selected
                        }
                    }
                )
            }
            setOpenSuccess(true)
            fetchAgroProducts()
        } catch (err) {
            setOpenFailed(true)
        }
    }

    async function handleUpdate() {
        const id = selected[0]
        history.push(`/agro-products/update/${id}`)
    }

    function handleSearch(e: React.ChangeEvent<HTMLInputElement>) {
        setSearch(e.target.value)
        if (e.target.value.trim() === '') {
            setFiltered(agroProducts)
        } else {
            const filteredProducts = agroProducts.filter(item => item.description.toLowerCase().includes(e.target.value.toLowerCase()))
            setFiltered(filteredProducts)
        }
    }

    const columns: ColDef[] = [
        { field: 'id', headerName: 'ID', width: 100 },
        { field: 'description', headerName: 'Nome', width: 200 },
        { field: 'year', headerName: 'Ano', width: 80 },
        { field: 'cod', headerName: 'Cód. de empreendimento', width: 200 },
        { field: 'category', headerName: 'Categoria', width: 150 },
        { field: 'unity', headerName: 'Unidade de Medida', width: 200 },
        { field: 'production', headerName: 'Produção Padrão', width: 150 },
        { field: 'value', headerName: 'Valor', width: 150 },
        { field: 'production_cost', headerName: 'Custo de produção', width: 200 },

    ];

    return (
        <Container>
            {
                loading ?
                    <Loading />
                    :
                    <Container>
                        <Link to="/agro-products/create" >
                            <Fab color="secondary" aria-label="add" className="floating-button">
                                <AddIcon />
                            </Fab>
                        </Link>
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <Typography variant="h4" style={{ marginBottom: 10, fontWeight: 600 }}>
                                Lista de empreendimentos
                            </Typography>
                            <div style={{ marginLeft: 50 }}>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    style={{ margin: '10px 10px' }}
                                    disabled={selected.length !== 1 ? true : false}
                                    onClick={handleUpdate}
                                >
                                    Atualizar
                                </Button>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    style={{ margin: '10px 10px' }}
                                    disabled={selected.length !== 1 ? true : false}
                                    onClick={handleDelete}
                                >
                                    Deletar
                                </Button>
                            </div>
                        </div>
                        <TextField
                            className="search-bar"
                            value={search}
                            label="Busque uma unidade"
                            variant="outlined"
                            onChange={handleSearch}
                        />
                        <DataTable columns={columns} rows={filtered} check={true} handleSelected={handleSelected} />
                        <Snackbar open={openSuccess} autoHideDuration={500} onClose={handleCloseSuccess}>
                            <Alert onClose={handleCloseSuccess} severity="success">
                                Empreendimento deletado com sucesso!
                            </Alert>
                        </Snackbar>

                        <Snackbar open={openFailed} autoHideDuration={2000} onClose={handleCloseFailed}>
                            <Alert onClose={handleCloseFailed} severity="error">
                                {errorMessage}
                            </Alert>
                        </Snackbar>
                        </Container>
            }
        </Container>
    );
}

export default AgroProducts